module.exports = __webpack_public_path__ + "static/Leva_Seitansicht_Kaffee-3e86ad041ccbe88808de35cffe5a936f.svg";